export const environment = {
  idleTimeout: 3600000,
  production: false,
  addressVerificationEnabled: false,
  apiUrl: 'https://api-stg.creconnects.com',
  recaptchaSiteKey: '6Ld7gmMqAAAAAKR67YHtYbEvVSCi25V4CDH9jGs-',
  env: 'stg',
};
